import React from "react";
import {
  Box,
  Paper,
  List,
  ListSubheader,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { H9TitleSmall } from "../../../../components/StyledComponents/Typography/Typography.tsx";
import { StyledIconButton } from "../../../../components/StyledComponents/Buttons/AuradineButtons.js";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { isEmpty, omit, omitBy } from "lodash";
import { format, parseISO } from "date-fns";
import { useTheme } from "../../../../ThemeContext/ThemeContext.js";

export const PriceProfile = React.memo((props) => {
  const { priceProfileData, isFetched, isLoading } = props;
  const { colors } = useTheme();

  let keysToOmit = [
    "siteList",
    "IPO",
    "siteConfig",
    "priceConfigName",
    "configName",
  ];
  const shouldRemoveExtraFields =
    priceProfileData.TunePreference !== "Energy Optimizer";
  if (shouldRemoveExtraFields) {
    keysToOmit = keysToOmit.concat([
      "EnergyPriceLowerThreshold",
      "EnergyPriceUpperThreshold",
      "RampDownTime",
      "RampUpTime",
    ]);
  }
  const cleanedPriceProfileData = omit(
    priceProfileData,
    keysToOmit
  );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding="0.25rem 0.5rem 0.25rem 1rem"
        alignItems={"center"}
      >
        <H9TitleSmall> Price profile </H9TitleSmall>
        <StyledIconButton colors={colors}>
          <KeyboardArrowRightIcon
            fontSize="medium"
          />
        </StyledIconButton>
      </Box>
      <>
        <List
          sx={{
            width: "100%",
            backgroundColor: colors.background.accent,
            borderRadius: "1.5rem",
          }}
        >
          {isFetched &&
            Object.keys(cleanedPriceProfileData).length >
              0 && (
              <>
                <ListItem>
                  <ListItemText
                    sx={{ color: colors.text.primary }}
                  >
                    {
                      cleanedPriceProfileData?.priceConfigName
                    }
                  </ListItemText>
                </ListItem>
                {Object.entries(
                  cleanedPriceProfileData
                ).map(([key, value]) => (
                  <ListItem>
                    <ListItemText
                      primary={key}
                      secondary={
                        key === "updatedAt"
                          ? format(
                              parseISO(value),
                              "MM/dd/yyyy HH:mm:ss "
                            )
                          : value
                      }
                      sx={{
                        "& .MuiListItemText-primary": {
                          color: colors.text.primary,
                        },
                        "& .MuiListItemText-secondary": {
                          color: colors.text.muted,
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </>
            )}
          {isFetched &&
            isEmpty(cleanedPriceProfileData) && (
              <>
                <ListItem>
                  <ListItemText 
                    secondary="No price profile configured "
                    sx={{
                      "& .MuiListItemText-secondary": {
                        color: colors.text.muted,
                      },
                    }}
                  />
                </ListItem>
              </>
            )}
        </List>
      </>
    </Box>
  );
});
